<form [formGroup]="qaForm" id="qaForm">
  <div formArrayName="qaTypesAndLabels">
    @for (process of getQATypeAndLabelRows().controls; track process; let i = $index) {
      <div>
        <div [formGroupName]="i" class="row">
          <!-- #region QA Types -->
          <div class="col-3">
            <label>QA Types <span style="color: red">*</span></label>
            <p-select
              #qaTypeId
              [maxlength]="50"
              optionValue="id"
              optionLabel="name"
              formControlName="qaTypeID"
              placeholder="Select a QA Type"
              [options]="itemList"
              (onChange)="enableDisableQATypes(); clearQATypeLabel(i); _srvDropDown.GetQATypeLabels(qaTypeId.value, i, showCalendar);"
              appendTo="body"
              [filter]="true"
            ></p-select>
          </div>
          <!-- #endregion QA Types -->
          <!-- #region QA Type Labels -->
          @if (_srvDropDown.qaTypeLabelList[i]) {
            <div class="col-4">
              <label>QA Type Labels <span style="color: red">*</span></label>
              <p-select
                #selectedQATypeLabel
                optionValue="id"
                optionLabel="name"
                formControlName="qaTypeLabelID"
                placeholder="Select a QA Type label"
                [options]="_srvDropDown.qaTypeLabelList[i].items"
                appendTo="body"
                (onChange)="sendData()"
                [filter]="true"
              ></p-select>
            </div>
          }
          <!-- #endregion QA Type Labels -->
          <!--#region QA Dates-->
          @if (showCalendar == 1 && _srvDropDown.qaTypeLabelList[i]) {
            <div class="col-3" formArrayName="qaDate">
              @for (calendar of getQADatesByIndex(i).controls; track calendar; let j = $index) {
                <div>
                  @if (_srvDropDown.splitQATypeLabelValues[i][j]) {
                    <div [formGroupName]="j">
                      <label for="qaDate">{{ _srvDropDown.splitQATypeLabelValues[i][j] }} <span style="color: red">*</span></label>
                      <p-datepicker
                        class="formCalendar"
                        name="qaDate"
                        formControlName="date"
                        dataType="string"
                        dateFormat="yy-mm-dd"
                        placeholder="Enter Date"
                        appendTo="body"
                        [readonlyInput]="true"
                        [showButtonBar]="true"
                        (ngModelChange)="sendData()"
                      ></p-datepicker>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!--#endregion QA Dates-->
        </div>
      </div>
    }
  </div>
</form>
<!-- #endregion QA Completion Dates -->

